export function diffLines(before, after) {
    const a = before.split('\n');
    const b = after.split('\n');
    const table = Array.from({ length: a.length + 1 }, () => new Array(b.length + 1).fill(0));
    for (let i = a.length - 1; i >= 0; i -= 1) {
        for (let j = b.length - 1; j >= 0; j -= 1) {
            table[i][j] = a[i] === b[j] ? table[i + 1][j + 1] + 1 : Math.max(table[i + 1][j], table[i][j + 1]);
        }
    }
    const out = [];
    let i = 0;
    let j = 0;
    while (i < a.length && j < b.length) {
        if (a[i] === b[j]) {
            out.push({ type: 'same', text: a[i] });
            i += 1;
            j += 1;
        }
        else if (table[i + 1][j] >= table[i][j + 1]) {
            out.push({ type: 'removed', text: a[i] });
            i += 1;
        }
        else {
            out.push({ type: 'added', text: b[j] });
            j += 1;
        }
    }
    for (; i < a.length; i += 1)
        out.push({ type: 'removed', text: a[i] });
    for (; j < b.length; j += 1)
        out.push({ type: 'added', text: b[j] });
    return out;
}
/** Whether anything differs, so a screen can say "identical" rather than draw a wall of grey. */
export function hasChanges(lines) {
    return lines.some((line) => line.type !== 'same');
}
